import React from 'react';
import FixedView from '../FixedView';
import moment from 'moment';
import Calender from './Calendar';
import { checkTranslation, translate } from '../../utils/useful';


const WeeksName =
    [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]
const MonthsName = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]
const YearsName = [
    '2023',
    '2022',
    '2021',
    '2020',
    '1999',
    '1998',
    '1997',
    '1996',
]

export default class CalendarSelectScope extends React.Component {
    constructor(props) {
        super(props)
        this.firstView = React.createRef();
        this.firstCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();

        this.state = {
            // calender: new Calender(),
            selectedDay: "",
            key: 'TEpyxZL1neC2JBZViuDaJ'


        }
    }

    componentDidMount() {
        this.setState({ showFixedViews: true })

        // this.setState({ data: this.props.data })
    }


    componentDidUpdate(prevProps) {
        if (this.props.currentCalendarView != prevProps.currentCalendarView) {
            this.setState({ showFixedViews: false }, () => {
                this.setState({ showFixedViews: true })
            })
        }

    }


    showMonthList = () => {
        console.log("DDD")
        this.firstView.showView()
    }
    showYearList = () => {
        this.yearView.showView()
    }

    selectDay = (year, month, day) => {
        let newDate = moment.utc();
        newDate.set('year', year);
        newDate.set('month', month - 1);
        newDate.set('date', day);
        this.setState({ selectedDay: [newDate.format('YYYY MM DD'), { day, month, year }] }, () => {
            // this.changeData()
        })
    }

    // changeData = () => {
    //     let showData = this.state.data
    //     let key = this.state.key
    //     if (showData) {
    //         showData = showData.filter(cdata => moment(cdata?.values[key]).format('YYYY MM DD') === this.state.selectedDay[0])
    //     }
    //     this.setState({ showData, })
    // }
    render() {
        const calender = this.props.currentCalendar;
        const week = calender?.getWeek();
        const rToday = calender?.getToday();
        let cToday = { year: calender?.toMoment().format('YYYY'), month: calender?.toMoment().format('MM'), day: 0 } // calenderToday
        // console.log(calender?.activeRange)
        // console.log(calender?.activeRange?.end?.moment?.format('DD MMM'))
        return (
            <div className='' style={{ direction: 'ltr' }}>


                <div style={{}} className="flexc">

                    {this.props.currentCalendarView == 'month' && (

                        <div className="flexc align-content-center ">

                            <button className=' rotate-180 flexcc' onClick={() => { calender?.goToPrev('month') }}>
                                <img src='/assets/icons/angle-right.svg' height={20} />
                            </button>

                            <div className='flexcc' style={{ minWidth: 147 }}>
                                <button onClick={() => this.showMonthList()} ref={el => this.firstCurrentNode = el} >
                                    <p className='text-normal  text-semibold'>{calender?.toMoment().format('MMMM')},</p>
                                </button>

                                <button className='mld-1'>
                                    <p className='text-normal  text-semibold' onClick={() => this.showYearList()} ref={el => this.yearCurrentNode = el} style={{}}>{calender?.toMoment().format('YYYY')}</p>
                                </button>

                                <div className='flexcc px-1'>
                                    <img src='/assets/icons/priority.svg' height={8} />
                                </div>
                            </div>


                            <button className=' flexcc' onClick={() => { calender?.goToNext('month') }}>
                                <img src='/assets/icons/angle-right.svg' height={20} />
                            </button>

                        </div>

                    )}



                    {(this.props.currentCalendarView == 'week' || this.props.currentCalendarView == "weekSingleDay") && (

                        <div className="flexc align-content-center ">

                            <button className=' rotate-180 flexcc' onClick={() => { calender?.goToPrev('week') }}>
                                <img src='/assets/icons/angle-right.svg' height={20} />
                            </button>

                            <div className='flexcc' style={{ minWidth: 147 }}>
                                <button onClick={() => this.showMonthList()} ref={el => this.firstCurrentNode = el} >
                                    <p className='text-small  text-semibold'>{calender?.activeRange?.start?.moment?.format('DD MMM')} - {calender?.activeRange?.end?.moment?.format('DD MMM')}</p>
                                </button>

                                <button className='mld-1'>
                                    <p className='text-small  text-semibold' onClick={() => this.showYearList()} ref={el => this.yearCurrentNode = el} style={{}}>{calender?.toMoment().format('YYYY')}</p>
                                </button>

                                <div className='flexcc px-1'>
                                    <img src='/assets/icons/priority.svg' height={8} />
                                </div>
                            </div>


                            <button className=' flexcc' onClick={() => { calender?.goToNext('week') }}>
                                <img src='/assets/icons/angle-right.svg' height={20} />
                            </button>

                        </div>

                    )}




                    {this.props.currentCalendarView == 'day' && (

                        <div className="flexc align-content-center ">

                            <button className=' rotate-180 flexcc' onClick={() => { calender?.goToPrev('day') }}>
                                <img src='/assets/icons/angle-right.svg' height={20} />
                            </button>

                            <div className='flexcc' style={{ minWidth: 147 }}>
                                <button onClick={() => this.showMonthList()} ref={el => this.firstCurrentNode = el} >
                                    <p className='text-small  text-semibold'>{calender.activeDay?.moment?.format('dd DD MMM')}</p>
                                </button>

                                <button className='mld-1'>
                                    <p className='text-small  text-semibold' onClick={() => this.showYearList()} ref={el => this.yearCurrentNode = el} style={{}}>{calender?.activeDay?.moment.format('YYYY')}</p>
                                </button>

                                <div className='flexcc px-1'>
                                    <img src='/assets/icons/priority.svg' height={8} />
                                </div>
                            </div>


                            <button className=' flexcc' onClick={() => { calender?.goToNext('day') }}>
                                <img src='/assets/icons/angle-right.svg' height={20} />
                            </button>

                        </div>

                    )}


                </div>

                {this.state.showFixedViews && (
                    <>
                        <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={20} xOffset={90} zIndex={10} width={300}>
                            <div className='month-list flexc flex-wrap py-2 px-2'>
                                {MonthsName.map((month, index) => {
                                    return (
                                        <button key={index} onClick={() => { calender?.setMonth(index + 1) }} className='text-start px-2 py-1 note-hover-box2 br-5' style={{ width: '33.3%' }}>
                                            <p className='text-small text-semibold'>{checkTranslation(month)}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </FixedView>

                        <FixedView ref={el => this.yearView = el} nodeRef={this.yearCurrentNode} showFocus={false} topOffset={20} xOffset={160} zIndex={10} width={300}>
                            <div className='month-list py-2 px-2'>
                                <p className='text-small text-bold text-center mb-2 mt-1'>{translate("Select Year")}</p>
                                <div className='flexc flex-wrap '>
                                    {YearsName.map((year, index) => {
                                        return (
                                            <button onClick={() => { calender?.setYear(year) }} className='text-center px-2 py-1 note-hover-box2 br-5' style={{ width: '33.3%' }}>
                                                <p className='text-small text-semibold'>{year}</p>
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        </FixedView>

                    </>

                )}




            </div >
        )
    }

}